import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EditWeekConfigPopup = ({ isOpen, onClose, weekConfig, onUpdate }) => {
  const [formData, setFormData] = useState({
    name: "",
    startDate: "",
    endDate: "",
  });

  useEffect(() => {
    if (weekConfig) {
      // Format dates to YYYY-MM-DD
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
      };

      setFormData({
        name: weekConfig.name,
        startDate: formatDate(weekConfig.startDate),
        endDate: formatDate(weekConfig.endDate),
      });
    }
  }, [weekConfig]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const start = new Date(formData.startDate);
    const end = new Date(formData.endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

    onUpdate({
      ...weekConfig,
      name: formData.name,
      startDate: formData.startDate, // Already in YYYY-MM-DD format
      endDate: formData.endDate, // Already in YYYY-MM-DD format
      amountDate: diffDays,
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-2xl mx-4"
      >
        <div className="px-8 py-6 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-2xl font-medium text-gray-900 dark:text-white">
            Chỉnh sửa tuần sự kiện
          </h3>
        </div>

        <form onSubmit={handleSubmit} className="p-8">
          <div className="space-y-6">
            <div>
              <label
                htmlFor="name"
                className="block text-lg text-left font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                Tên tuần
              </label>
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 text-base p-3 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                required
              />
            </div>
            <div>
              <label
                htmlFor="startDate"
                className="block text-lg text-left font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                Ngày bắt đầu
              </label>
              <input
                type="date"
                name="startDate"
                id="startDate"
                value={formData.startDate}
                onChange={(e) =>
                  setFormData({ ...formData, startDate: e.target.value })
                }
                className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 text-base p-3 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                required
              />
            </div>
            <div>
              <label
                htmlFor="endDate"
                className="block text-lg text-left font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                Ngày kết thúc
              </label>
              <input
                type="date"
                name="endDate"
                id="endDate"
                value={formData.endDate}
                onChange={(e) =>
                  setFormData({ ...formData, endDate: e.target.value })
                }
                className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 text-base p-3 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                required
              />
            </div>
          </div>

          <div className="mt-8 flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:hover:bg-gray-600"
            >
              Hủy
            </button>
            <button
              type="submit"
              className="px-6 py-3 text-base font-medium text-white bg-purple-600 border border-transparent rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
            >
              Cập nhật
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
};

export default EditWeekConfigPopup;
